import apiHandler from '../apiHandler';
import { METHOD } from '../constants';
import { PATHS } from '../utils';

const fetchOrdersFromDMS = async (
  authorization: string,
  requestPayload: any
): Promise<unknown> => {
  const response = await apiHandler({
    url: PATHS.GET_DMS_ORDERS,
    method: METHOD.POST,
    headers: { authorization },
    reqObj: requestPayload
  });
  if (!response.ok) throw new Error(response.status + "");

  return (await response.json()) as Promise<unknown>;
};

export default fetchOrdersFromDMS;